jQuery(document).ready(function ($) {

    find_URLSearchParams_args();

    var tel_input = document.querySelector("#CreatePhone");
if (tel_input) {
    var iti = intlTelInput(tel_input, { 
        initialCountry: 'au' 
    });

    tel_input.addEventListener("countrychange", function() {
        const countryData = iti.getSelectedCountryData();
        const currentValue = tel_input.value;
        set_country_value(countryData.dialCode, currentValue);
    });

    tel_input.addEventListener("change", function() {
        const countryData = iti.getSelectedCountryData();
        const currentValue = tel_input.value;
        set_country_value(countryData.dialCode, currentValue);
    });
}

function set_country_value( dial_code, dial_number) {
  
    document.querySelector("#setdial_number").value = '+'+dial_code+' '+dial_number;
}

   jQuery(document).on("click",'.size_guide_button',function(){
   if( !jQuery('.switcher_size_guide').hasClass('active') ){
      jQuery('.switcher_size_guide .spinner_overlay').show();
     jQuery('.switcher_size_guide').addClass('active');
     setTimeout(function(){
            var main_container = jQuery('.modal.fade.show .modal-content .shg-box-vertical-align-wrapper .create_js_tabel');
            convert_table(main_container);
    },1000);
   }
    
});

 setTimeout(function(){
        
        var main_container = jQuery('.page.content.container .create_js_tabel');

convert_table(main_container);



// function swap( cells, x, y ){
//    if( x != y ){     
//    var $cell1 = cells[y][x];
//    var $cell2 = cells[x][y];
//    $cell1.replaceWith( $cell2.clone() );
//    $cell2.replaceWith( $cell1.clone() );
//     }
// }

// var cells = [];
// $('.page.content.container .create_js_tabel').find('tr').each(function(){
//     var row = [];
//     $(this).find('td').each(function(){
//        row.push( $(this) );    
//     });
//     cells.push( row );
// });

// for( var y = 0; y <= cells.length/2; y++ ){
//     for( var x = 0; x < cells[y].length; x++ ){
//         swap( cells, x, y );
//     }   
// }

    }, 400);


    setTimeout(function () {
        jQuery('.sk-list-collection .snize-filters-sidebar')
            .before('<button class="custom-sk-close filter__custom-dropdown__close-button"><svg width="30" height="29" viewBox="0 0 30 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.92871 7.07129L22.0708 21.2134" stroke="#231F20"></path><path d="M22.0713 7.07129L7.92915 21.2134" stroke="#231F20"></path></svg></button>');
        jQuery('.sk-list-collection .snize-main-panel-dropdown').before('<div class="facet-filters__label facet-filters__label-sk custom-sk-filter">FILTER +</div>')
        .after('<div class="facet-filters__label custom-sk-view" data-value="2"> View X  <span class="custom-sk-view-count">2</span></div>');

          if (isMobile()) {
              data_val = 2;
              text_data_val = 1;
          }else{
               data_val = 4;
              text_data_val = 2;
          }

         jQuery('.sk-list-collection .facet-filters__label.custom-sk-view').attr('data-value', data_val).find('.custom-sk-view-count').text(text_data_val);
         jQuery('.sk-list-collection').addClass('sk-view-grid-' + data_val);

      
/*$(".phone-flag").countrySelect({
				preferredCountries: ['ca', 'gb', 'us']
			});*/


    }, 1000);

    jQuery(document).on('click', '.sk-list-collection .facet-filters__label.custom-sk-filter', function () {

        if (jQuery('.sk-list-collection .custom-sk-close').length == 0) {
            jQuery('.sk-list-collection .snize-filters-sidebar')
                .before('<button class="custom-sk-close filter__custom-dropdown__close-button"><svg width="30" height="29" viewBox="0 0 30 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.92871 7.07129L22.0708 21.2134" stroke="#231F20"></path><path d="M22.0713 7.07129L7.92915 21.2134" stroke="#231F20"></path></svg></button>');
        }

        if (jQuery('.sk-list-collection div.snize div.snize-filters-sidebar.active').length > 0) {
            jQuery('.sk-list-collection div.snize div.snize-filters-sidebar').removeClass('active');
            jQuery('.sk-list-collection .custom-sk-close').removeClass('active');
        } else {
            jQuery('.sk-list-collection div.snize div.snize-filters-sidebar').addClass('active');
            jQuery('.sk-list-collection .custom-sk-close').addClass('active');
        }
        find_URLSearchParams_args();
    });

    jQuery(document).on('click', '.sk-list-collection  .custom-sk-close', function () {
        jQuery('.sk-list-collection div.snize div.snize-filters-sidebar').removeClass('active');
            jQuery('.sk-list-collection .custom-sk-close').removeClass('active');
            find_URLSearchParams_args();
    });

    jQuery(document).on('click', '.sk-list-collection  .snize-clear-all-filter', function () {
        if (jQuery('.sk-list-collection .custom-sk-close').length == 0) {
            jQuery('.sk-list-collection .snize-filters-sidebar')
                .before('<button class="custom-sk-close filter__custom-dropdown__close-button"><svg width="30" height="29" viewBox="0 0 30 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.92871 7.07129L22.0708 21.2134" stroke="#231F20"></path><path d="M22.0713 7.07129L7.92915 21.2134" stroke="#231F20"></path></svg></button>');
            find_URLSearchParams_args();
        }
    });

    jQuery(document).on( 'click', '.filter-advance-dropdown button', function () {
        if( jQuery(this).parents('.snize-mobile-design').length == 0 ){
            jQuery('body').addClass('wc-active');
            jQuery('.wc-filter-sidebar-wrapper').addClass('wc-active');
        }else{
jQuery('.snize-main-panel-mobile-filters').click();
        }
    });

   jQuery(document).on( 'click', '.filter-button-cross,.wc-apply-btn', function () {
             if( jQuery(this).parents('.snize-mobile-design').length == 0 ){
                    jQuery('body').removeClass('wc-active');
                    jQuery('.wc-filter-sidebar-wrapper').removeClass('wc-active');
             }else{

            }
  });

   jQuery(document).on( 'click', '.wc-remove-filter', function () {
      var data_value = jQuery(this).closest('.wc-active-item').attr('data-attr');
      var data_id = jQuery(this).closest('.wc-active-item').attr('data-id');   
      if( jQuery('.snize-product-filters-block#'+data_id).length > 0 ){
        jQuery('.snize-product-filters-block#'+data_id+' .snize-filter-checkbox').each(function () {
          if( jQuery(this).find('input').val() == data_value ){
            
            //jQuery(this).find('input').prop('checked',false).change();
            jQuery(this).find('input').click();
            load_active_filter_item();
          }
        });
      }
   } );

    jQuery(window).scroll(function(){
     /* if( jQuery('.filter-dropdown-wrapper').length > 0 ){
          var filter_sticky = jQuery('.filter-dropdown-wrapper').offset().top;
          var filterscroll = jQuery(window).scrollTop();
          if (filterscroll >= filter_sticky + 150){
              sticky.addClass('wc-filter-fixed');
              jQuery('body').removeClass('wc-filter-fixed');
          }else{
               sticky.addClass('wc-filter-fixed');
               jQuery('body').removeClass('wc-filter-fixed');
          }
      }  */  
  });

   jQuery(document).on( 'click', '.wc-clear-btn', function () {
      jQuery('.snize-clear-all-filter').click();
   });

    jQuery(document).on('change', '.sk-list-collection  .snize-product-filters-list', function () {
      find_URLSearchParams_args();
      setTimeout(function () {
          if (jQuery('.sk-list-collection .custom-sk-close').length == 0) {
              jQuery('.sk-list-collection .snize-filters-sidebar')
                  .prepend('<button class="custom-sk-close filter__custom-dropdown__close-button"><svg width="30" height="29" viewBox="0 0 30 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.92871 7.07129L22.0708 21.2134" stroke="#231F20"></path><path d="M22.0713 7.07129L7.92915 21.2134" stroke="#231F20"></path></svg></button>');

          }
      }, 1000);
    });
  
    setInterval(function () {

        if (jQuery('.sk-list-collection .facet-filters__label-sk').length == 0) {
       
            jQuery('.sk-list-collection .snize-main-panel-dropdown').before('<div class="facet-filters__label facet-filters__label-sk custom-sk-filter">FILTER +</div>').after('<div class="facet-filters__label custom-sk-view" data-value="4"> View X <span class="custom-sk-view-count">2</span></div>').find('span').text('SORT +');
        }

          if (jQuery('.wc-collection-new-layout .filter-advance-dropdown').length == 0) {
          //  debugger;
            jQuery('.wc-collection-new-layout .snize-main-panel-dropdown').before('<div class="filter-advance-dropdown"><button type="button" class="chakra-button css-1t00883"><p class="chakra-text css-1l9rtf0">Filters</p><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M0 416c0 17.7 14.3 32 32 32l54.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 448c17.7 0 32-14.3 32-32s-14.3-32-32-32l-246.7 0c-12.3-28.3-40.5-48-73.3-48s-61 19.7-73.3 48L32 384c-17.7 0-32 14.3-32 32zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32-80c-32.8 0-61 19.7-73.3 48L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l246.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48l54.7 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-54.7 0c-12.3-28.3-40.5-48-73.3-48zM192 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm73.3-64C253 35.7 224.8 16 192 16s-61 19.7-73.3 48L32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l86.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 128c17.7 0 32-14.3 32-32s-14.3-32-32-32L265.3 64z"/></svg></button></div>');        
            jQuery('.wc-collection-new-layout .snize-main-panel-dropdown, .wc-collection-new-layout .filter-advance-dropdown').wrapAll('<div class="footer-dropdown-main"><div class="filter-dropdown-wrapper"></div></div>');
           jQuery('a.snize-main-panel-dropdown-button').attr('style','display:flex !important');
            jQuery('.filter-dropdown-wrapper').prepend('<div class="wc-collection__title">'+jQuery('.wc_main-collection-new .collection__title').text()+'</div>');

              if( jQuery('.wc-collection-new-layout .wc-filter-sidebar-wrapper').length == 0 ){
                  jQuery('.wc-collection-new-layout .snize-filters-sidebar').wrapAll('<div class="wc-filter-sidebar-wrapper"></div>');
               }
            
            jQuery('.wc-collection-new-layout .snize-filters-sidebar').prepend('<div class="wc-filter-header"><h2 class="filter-header-label">Filters</h2><button type="button" class="filter-button-cross" aria-label="Close Filter Drawer"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg></button></div>');
            jQuery('.wc-collection-new-layout .snize-filters-sidebar').append('<div class="wc-extra-button"><button type="button" class="wc-clear-btn">Clear</button><button type="button" class="wc-apply-btn">Apply</button></div>');
            load_active_filter_item();
           jQuery('.spinner_overlay').removeClass('wc-force-active');
            jQuery('.wc-collection-new-layout').removeClass('wc-hide');
            window.dispatchEvent(new Event('resize'));

        }
    }, 1000);

    var intervalID = setInterval(function () {

        if (jQuery('.sk-list-collection .facet-filters__label-sk').length == 0) {
    // jQuery('.spinner_overlay').addClass('wc-force-active');
    //         jQuery('.wc-collection-new-layout').addClass('wc-hide');
            jQuery('.sk-list-collection .snize-main-panel-dropdown').before('<div class="facet-filters__label facet-filters__label-sk custom-sk-filter">FILTER +</div>').after('<div class="facet-filters__label custom-sk-view" data-value="4"> View X <span class="custom-sk-view-count">2</span></div>').find('span').text('SORT +');            
        }

       if (jQuery('.wc-collection-new-layout .filter-advance-dropdown').length == 0) {
            jQuery('.wc-collection-new-layout .snize-main-panel-dropdown').before('<div class="filter-advance-dropdown"><button type="button" class="chakra-button css-1t00883"><p class="chakra-text css-1l9rtf0">Filters</p><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M0 416c0 17.7 14.3 32 32 32l54.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 448c17.7 0 32-14.3 32-32s-14.3-32-32-32l-246.7 0c-12.3-28.3-40.5-48-73.3-48s-61 19.7-73.3 48L32 384c-17.7 0-32 14.3-32 32zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32-80c-32.8 0-61 19.7-73.3 48L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l246.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48l54.7 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-54.7 0c-12.3-28.3-40.5-48-73.3-48zM192 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm73.3-64C253 35.7 224.8 16 192 16s-61 19.7-73.3 48L32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l86.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 128c17.7 0 32-14.3 32-32s-14.3-32-32-32L265.3 64z"/></svg></button></div>');        
            jQuery('.wc-collection-new-layout .snize-main-panel-dropdown, .wc-collection-new-layout .filter-advance-dropdown').wrapAll('<div class="footer-dropdown-main"><div class="filter-dropdown-wrapper"></div></div>');
         jQuery('a.snize-main-panel-dropdown-button').attr('style','display:flex !important');  
         jQuery('.filter-dropdown-wrapper').prepend('<div class="wc-collection__title">'+jQuery('.wc_main-collection-new .collection__title').text()+'</div>');
           
            if( jQuery('.wc-collection-new-layout .wc-filter-sidebar-wrapper').length == 0 ){
                 jQuery('.wc-collection-new-layout .snize-filters-sidebar').wrapAll('<div class="wc-filter-sidebar-wrapper"></div>');
            }
            jQuery('.wc-collection-new-layout .snize-filters-sidebar').prepend('<div class="wc-filter-header"><h2 class="filter-header-label">Filters</h2><button type="button" class="filter-button-cross" aria-label="Close Filter Drawer"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg></button></div>');
            jQuery('.wc-collection-new-layout .snize-filters-sidebar').append('<div class="wc-extra-button"><button type="button" class="wc-clear-btn">Clear</button><button type="button" class="wc-apply-btn">Apply</button></div>');
            load_active_filter_item();
            jQuery('.spinner_overlay').removeClass('wc-force-active');
            jQuery('.wc-collection-new-layout').removeClass('wc-hide');
           window.dispatchEvent(new Event('resize'));

        }
    }, 500); 

    setTimeout(function () {
        clearInterval(intervalID);
    }, 3000);

    jQuery(document).on('change', '.sk-list-collection  .snize-main-panel-dropdown .snize-main-panel-dropdown-content li a', function () {
        setTimeout(function () {
        if (jQuery('.sk-list-collection .facet-filters__label-sk').length == 0) {
              jQuery('.sk-list-collection .snize-main-panel-dropdown').before('<div class="facet-filters__label facet-filters__label-sk custom-sk-filter">FILTER +</div>').after('<div class="facet-filters__label custom-sk-view" data-value="4"> View X <span class="custom-sk-view-count">2</span></div>').find('span').text('SORT +');

            }
        }, 1000);
    });

    jQuery(document).on('click', '.sk-list-collection .facet-filters__label.custom-sk-view', function () {
        var current_view = jQuery(this);
        var all_class = jQuery('.sk-list-collection').attr('class');
        var substring = 'sk-view-grid-';
        var data_val = current_view.attr('data-value');
  
        if (isMobile()) {
          if( data_val == 2 ){
                  data_val = 1;
                  text_data_val = 2;
              }else{
                data_val = 2;
                text_data_val = 1;
            } 
        } else {
           if( data_val == 2 ){
                  data_val = 4;
                  text_data_val = 2;
             }else{
                 data_val = 2;
                 text_data_val = 4;
            } 
        }

        if (all_class) {
            var classArray = all_class.split(' ');
            var containsSubstring = false;
            
            jQuery.each(classArray, function (index, val) {
                if (val.indexOf(substring) !== -1) {
                    jQuery('.sk-list-collection').removeClass(val);
                    containsSubstring = true;
                }
            });

            current_view.find('.custom-sk-view-count').text(text_data_val);
            current_view.parents('.sk-list-collection').addClass('sk-view-grid-' + data_val);
            current_view.attr('data-value', data_val);
        }
    });


jQuery(document).mouseup(function(e)
{
var container = jQuery(".wc-filter-sidebar-wrapper");

// if the target of the click isn't the container nor a descendant of the container
if (!container.is(e.target) && container.has(e.target).length === 0)
{
container.removeClass('wc-active');
            jQuery('body').removeClass('wc-active');
}
});

    function isMobile() {
        return window.innerWidth < 768;
    }
  
    function load_active_filter_item() {
        var check_filter_html = '';
        if( jQuery('.wc-collection-new-layout .snize-product-filters .snize-filter-checkbox').length > 0 ){
            jQuery('.wc-collection-new-layout .snize-product-filters .snize-filter-checkbox').each(function(){		        
    
                var data_id = jQuery(this).closest('.snize-product-filters-block').attr('id');
    
                if( jQuery(this).find('input').prop('checked') == true ){
                    var span_label = jQuery(this).siblings('.needsclick').text();
                    var span_cnt = jQuery(this).closest('label').find('.snize-filter-variant-count').text();               
                  span_label = span_label.replace( span_cnt, '' );
                  span_label = span_label.trim();
                    check_filter_html += '<div class="wc-active-item" data-attr="'+span_label+'" data-id="'+data_id+'" >'+span_label+'<span class="wc-remove-filter"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg></span></div>';
                }
            });
        }
        if( check_filter_html ){
            jQuery('.wc-extra-button').removeClass('wc-hide-box');
            jQuery('.snize-filters-sidebar.snize-product-filters').removeClass('wc-remove-padding');
        }else{
            jQuery('.wc-extra-button').addClass('wc-hide-box');
          jQuery('.snize-filters-sidebar.snize-product-filters').addClass('wc-remove-padding')
        }
      if( jQuery('ul.snize-product-filters-list li').length > 0 ){
	jQuery('ul.snize-product-filters-list li').each(function () {
    var value = jQuery(this).find('.needsclick').text();
    var count = jQuery(this).find('.snize-filter-variant-count').text();
    value = value.replace( count, '', value );
    value = value.trim();
    if( value == 'Handbags' ){
        jQuery(this).hide();
    }
    
});

}
        jQuery('.wc-collection-new-layout .wc-active-item-box').remove();
        jQuery('.wc-collection-new-layout .wc-filter-header').after('<div class="wc-active-item-box">'+check_filter_html+'</div>');
       
        find_URLSearchParams_args();
    }
  
    function find_URLSearchParams_args() {
    
    	var serch_parm = setInterval(function(){
        var queryString = window.location.search;
    	var searchParams = new URLSearchParams(queryString);
    	var foundRBParameter = false;
    
    	searchParams.forEach(function(value, key) {
           if (/^rb_/.test(key)) {
                foundRBParameter = true;
                return false; // Exit forEach loop early since we found what we need
            }
    	});
    
          if (jQuery('.filter-advance-dropdown .chakra-button').length > 0 ) {
            if (foundRBParameter && jQuery('.main-filter').length == 0 ) {

                jQuery('.filter-advance-dropdown .chakra-button').before('<div class="main-filter"><a href="#" class="snize-clear-all-filter">Clear all</a></div>');
            jQuery('.wc-extra-button').removeClass('wc-hide-box');

            }else{
                jQuery('.filter-advance-dropdown .main-filter').remove();
            } 
            clearInterval(serch_parm);
         }
    	});
    }

function convert_table(main_container) {
       
      var table_html = '';

        if( main_container.find('tr:first-child td').length > 0 ){
            table_html = '<table><tbody>';

            var total =  main_container.find('tr:first-child td').length;

            for (let i = 0; i < total; i++) {
                table_html += '<tr>';
                 main_container.find('tr').each(function(){
                    var current_tr = jQuery(this);
                    var table_td = current_tr.find('td').eq(i).text();
                    table_html += '<td>'+table_td+'</td>';
                });
                table_html += '</tr>';
            }

            table_html += '</tbody></table>';
        }
        main_container.html(table_html);
       jQuery('.switcher_size_guide .spinner_overlay').hide();
    if( jQuery('.size-guide-width').length > 0 ){
      jQuery('.size-guide-width').removeClass('active');
      jQuery('.size-guide-width .spinner_overlay').hide();
    }
}

});